import jquery from 'jquery';
import DataTable from 'datatables.net-bs5';
import 'datatables.net-buttons-bs5';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.print.js';
import jszip from 'jszip';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

import moment from "moment"
import "daterangepicker"
import { logo } from './images';
window.$ = jquery;
window.jQuery = jquery;


  $(document).on('change', '#user_filter_select', function () {
    const url = new URL(window.location.href);
    url.searchParams.set('user_id', $(this).val());
    window.location.href = url.toString();
  });

$(document).on('turbo:load', function () {

  initializeDataTable({
    selector: '#internal_users_table',
    columns: [
      { data: "full_name" },
      { data: "email" },
      { data: "role" },
      { data: "active" },
      { data: "created_at" },
      { data: "actions", orderable: false, searchable: false }
    ]
  });

  initializeDataTable({
    selector: '#users_table',
    columns: [
      { data: "first_name" },
      { data: "phone" },
      { data: "email" },
      { data: "status"},
      { data: "plan"},
      { data: "billing_cycle" },
      { data: "plan_price" },
      { data: "total_paid" },
      { data: "created_at" },
      { data: "actions", orderable: false, searchable: false }
    ],
    order: [[5, 'desc']]
  });

  initializeDataTable({
    selector: '#marketplaces_table',
    columns: [
      { data: "logo", orderable: false, searchable: false },
      { data: "name" },
      { data: "base_url" },
      { data: "redirect_url" },
      { data: "active" },
      { data: "actions", orderable: false, searchable: false }
    ]
  });

  initializeDataTable({
    selector: '#report_definitions_table',
    columns: [
      { data: "name" },
      { data: "active" },
      { data: "marketplace" },
      { data: "created_at" },
      { data: "actions", orderable: false, searchable: false }
    ],
    extraAjaxData: { marketplace_id: $("#report_definitions_table").data("report_definition_id") }
  });

  initializeDataTable({
    selector: '#report_type_snapshots_table',
    columns: [
      { data: "name" },
      { data: "column_name" },
      { data: "report_definition" },
      { data: "fetched_at" },
      { data: "actions", orderable: false, searchable: false }
    ],
    extraAjaxData: { marketplace_id: $("#report_type_snapshots_table").data("report_type_snapshot_id") }
  });

  initializeDataTable({
    selector: '#report_processings_table',
    columns: [
      { data: "id" },
      { data: "marketplace_account" },
      { data: "report_definition" },
      { data: "status" },
      { data: "marketplace_status" },
      { data: "period_start" },
      { data: "period_end" },
      { data: "downloaded_at" },
      { data: "processed_at" },
      { data: "job_assign_at" },
      { data: "created_at" },
      { data: "error_message" },
      { data: "actions", orderable: false, searchable: false }
    ],
    extraAjaxData: { marketplace_id: $("#report_processings_table").data("report_processing_id") },
    order: [[1, 'desc']],
  });

  initializeDataTable({
    selector: '#marketplace_accounts_table',
    columns: [
      { data: 'id' },
      { data: 'name' },
      { data: 'marketplace' },
      { data: "user_name" },
      { data: 'external_id' },
      { data: 'active' },
      { data: 'last_sync' },
      { data: 'paid_status' },
      { data: 'actions', orderable: false, searchable: false }
    ],
    extraAjaxData: {
      marketplace_id: $("#marketplace_accounts_table").data("marketplace-id"),
      user_id: $("#marketplace_accounts_table").data("user-id"),
    }
  });

  initializeDataTable({
    selector: '#admin_marketplace_accounts_table',
    columns: [
      { data: 'id' },
      { data: 'name' },
      { data: 'marketplace' },
      { data: 'user_name' },
      { data: 'external_id' },
      { data: 'active' },
      { data: 'last_sync' },
      { data: 'paid_status' },
      { data: 'actions', orderable: false, searchable: false }
    ],
    extraAjaxData: { marketplace_id: $("#admin_marketplace_accounts_table").data("admin-marketplace-id") }
  });

  initializeDataTable({
    selector: '#admin_postal_codes_table',
    columns: [
      { data: 'pincode' },
      { data: 'area' },
      { data: 'district' },
      { data: 'division' },
      { data: 'region' },
      { data: 'state' },
      { data: 'latitude' },
      { data: 'longitude' },
      { data: 'actions', orderable: false, searchable: false }
    ],
    extraAjaxData: { marketplace_id: $("#admin_postal_codes_table").data("admin-postal-code-id") }
  });



  initializeDataTable({
    selector: '#orders_table',
    columns: [
      { data: "marketplace_id" },
      { data: "product_id" },
      { data: "marketplace_account_id" },
      { data: "is_business_order" },
      { data: "external_order_id" },
      { data: "status" },
      { data: "fulfillment_channel" },
      { data: "currency" },
      { data: "quantity" },
      { data: "purchase_at" },
      { data: "total_sale_amount" },
      { data: "total_net_sale_amount" },
      { data: "refund" },
      { data: "product_price" },
      { data: "payment_mode" }
    ]
  });

  initializeDataTable({
    selector: '#contact_message_table',
    columns: [
      { data: "id" },
      { data: "name" },
      { data: "email" },
      { data: "subject" },
      { data: "message" },
      { data: "actions", orderable: false, searchable: false }
    ]
  })

  initializeDataTable({
    selector: '#onboarding_table',
    ajax: '/admin/onboardings.json',
    columns: [
      { data: "id" },
      { data: "name" },
      { data: "email" },
      { data: "phone" },
      { data: "created_at" },
      { data: "actions", orderable: false, searchable: false }
    ],
    order: [[0, 'desc']]
  });


  initializeDataTable({
    selector: '#app_review_table',
    columns: [
      { data: 'id' },
      { data: 'user_name' },
      { data: 'rating' },
      { data: 'comment' },
      { data: 'show_on_public_page' },
      { data: 'created_at' },
      { data: 'actions', orderable: false, searchable: false }
    ]
  })

  // { data: "charges_deducted_from_seller" },
  initializeDataTable({
    selector: '#admin_orders_table',
    columns: [
      { data: "product_id" },
      { data: "sku" },
      { data: "asin" },
      { data: "parent_asin"},
      { data: "external_order_id" },
      { data: "purchase_at" },
      { data: "user_name" },
      { data: "product_price" },
      { data: "customer_shipping_fee" },
      { data: "additional_expenses" },
      { data: "refund_commission_fee" },
      { data: "total_sale_amount" },
      { data: "total_net_sale_amount" },
      { data: "actual_net_sale_amount" },
      { data: "quantity" },
      { data: "is_business_order" },
      { data: "status" },
      { data: "return_at" },
      { data: "return_quantity" },
      { data: "replacement_order_id" },
      { data: "replacement_quantity" },
      { data: "promotion_amount" },
      { data: "promo_rebates" },
      { data: "principal" },
      { data: "product_tax" },
      { data: "fulfilled_by" },
      { data: "to_state" },
      { data: "from_state" },
      { data: "to_service_level" },
      { data: "zone" },
      { data: "actions" }
    ]

  });


  initializeDataTable({
    selector: '#products_table',
    columns: [
      { data: "sku" },
      { data: "asin" },
      { data: "title" },
      { data: "user_name" },
      { data: "price" },
      { data: "mrp" },
      { data: "marketplace_account_id" },
      { data: "condition" },
      { data: "fulfillment_channel" },
      { data: 'browse_nodes' },
      { data: "status" },
      { data: "quantity" },
      { data: "marketplace" }
      // { data: "actions", orderable: false, searchable: false }
    ]
  });

  $('#activity-table').DataTable({
    dom: "<'row custom_data_filter_col'<'col-6 custom_datatable'f><'col-6 text-end d-flex justify-content-end align-items-center gap-2'B<'filter-btn-wrap'>>>" +
      "<'row'<'col-sm-12 table-responsive hide-scrollbar 'tr>>" +
      "<'row mgltm0'<'col-sm-5 show-entry'li><'col-sm-7'p>>",
    buttons: buttonsConfig("Data Export"),
    oLanguage: {
      sLengthMenu: "Show Entries _MENU_",
      sProcessing: "<div class='ld_ind_wrp'></div>",
      sSearch: "",
      oPaginate: {
        sNext: '<i class="bi bi-chevron-right"></i>',
        sPrevious: '<i class="bi bi-chevron-left"></i>'
      }
    },
  }).buttons().container().find('button').each(function () {
    const buttonClass = $(this).attr('class').split(' ').find(cls => cls.startsWith('buttons-'));
    if (buttonClass && iconClasses[buttonClass]) {
      const label = buttonClass.split('-')[1].toUpperCase();
      $(this).html(`<i class="bi ${iconClasses[buttonClass]} me-1"></i>`);
      $(this).attr("title", label);
    }
  });

  $('#referrals_table').DataTable({
    dom: "<'row custom_data_filter_col'<'col-6 custom_datatable'f><'col-6 text-end d-flex justify-content-end align-items-center gap-2'B<'filter-btn-wrap'>>>" +
      "<'row'<'col-sm-12 table-responsive hide-scrollbar'tr>>" +
      "<'row mgltm0'<'col-sm-5 show-entry'li><'col-sm-7'p>>",
    buttons: buttonsConfig("Data Export"),
    oLanguage: {
      sLengthMenu: "Show Entries _MENU_",
      sProcessing: "<div class='ld_ind_wrp'></div>",
      sSearch: "",
      oPaginate: {
        sNext: '<i class="bi bi-chevron-right"></i>',
        sPrevious: '<i class="bi bi-chevron-left"></i>'
      }
    }
  }).buttons().container().find('button').each(function () {
    const buttonClass = $(this).attr('class').split(' ').find(cls => cls.startsWith('buttons-'));
    if (buttonClass && iconClasses[buttonClass]) {
      const label = buttonClass.split('-')[1].toUpperCase();
      $(this).html(`<i class="bi ${iconClasses[buttonClass]} me-1"></i>`);
      $(this).attr("title", label);
    }
  });

  $('#comment-table').DataTable({
    dom: "<'row custom_data_filter_col'<'col-6 custom_datatable'f><'col-6 text-end d-flex justify-content-end align-items-center gap-2'B<'filter-btn-wrap'>>>" +
      "<'row'<'col-sm-12 table-responsive hide-scrollbar'tr>>" +
      "<'row mgltm0'<'col-sm-5 show-entry'li><'col-sm-7'p>>",
    oLanguage: {
      sLengthMenu: "Show Entries _MENU_",
      sProcessing: "<div class='ld_ind_wrp'></div>",
      sSearch: "",
      oPaginate: {
        sNext: '<i class="bi bi-chevron-right"></i>',
        sPrevious: '<i class="bi bi-chevron-left"></i>'
      }
    },
  }).buttons().container().find('button').each(function () {
    const buttonClass = $(this).attr('class').split(' ').find(cls => cls.startsWith('buttons-'));
    if (buttonClass && iconClasses[buttonClass]) {
      const label = buttonClass.split('-')[1].toUpperCase();
      $(this).html(`<i class="bi ${iconClasses[buttonClass]} me-1"></i>`);
      $(this).attr("title", label);
    }
  });

  initializeDataTable({
    selector: "#support-tickets",
    columns: [
      { data: "id" },
      { data: "subject" },
      { data: "user_name" },
      { data: "internal_user_id" },
      { data: "category" },
      { data: "priority" },
      { data: "status" },
      { data: "created_at" },
      { data: "actions", orderable: false, searchable: false }
    ]
  })

  initializeDataTable({
    selector: "#analytics_sale_table",
    columns: [
      { data: 'posted_at' },
      { data: 'marketplace_account_id' },
      { data: 'avg_sales_per_order_item_b2c' },
      { data: 'avg_sales_per_order_item_b2b' },
      { data: 'avg_selling_price_b2c' },
      { data: 'avg_selling_price_b2b' },
      { data: 'avg_units_per_order_item_b2c' },
      { data: 'avg_units_per_order_item_b2b' },
      { data: 'claims_amount' },
      { data: 'claims_granted' },
      { data: 'ordered_product_sales_b2c' },
      { data: 'ordered_product_sales_b2b' },
      { data: 'shipped_product_sales' },
      { data: 'total_order_items_b2c' },
      { data: 'total_order_items_b2b' },
      { data: 'orders_shipped' },
      { data: 'refund_rate' },
      { data: 'units_ordered' },
      { data: 'units_ordered_b2b' },
      { data: 'units_refunded' },
      { data: 'units_shipped' },
      { data: 'created_at' },
      { data: 'updated_at' },
      { data: 'actions', orderable: false, searchable: false }
    ]
  })

  initializeDataTable({
    selector: "#analytics_traffic_table",
    columns: [
      { data: 'posted_at' },
      { data: 'marketplace_account_id' },
      { data: 'avg_offer_count' },
      { data: 'avg_parent_items' },
      { data: 'browser_page_views_b2c' },
      { data: 'browser_page_views_b2b' },
      { data: 'browser_sessions_b2c' },
      { data: 'browser_sessions_b2b' },
      { data: 'mobile_app_page_views_b2c' },
      { data: 'mobile_app_page_views_b2b' },
      { data: 'mobile_app_sessions_b2c' },
      { data: 'mobile_app_sessions_b2b' },
      { data: 'buy_box_percentage_b2c' },
      { data: 'buy_box_percentage_b2b' },
      { data: 'feedback_received' },
      { data: 'negative_feedback_received' },
      { data: 'received_negative_feedback_rate' },
      { data: 'order_item_session_percentage_b2c' },
      { data: 'order_item_session_percentage_b2b' },
      { data: 'unit_session_percentage_b2c' },
      { data: 'unit_session_percentage_b2b' },
      { data: 'page_views_b2c' },
      { data: 'page_views_b2b' },
      { data: 'sessions_b2c' },
      { data: 'sessions_b2b' },
      { data: 'created_at' },
      { data: 'updated_at' },
      { data: 'actions', orderable: false, searchable: false }
    ]
  })

  initializeDataTable({
    selector: "#analytics_product_table",
    columns: [
      { data: 'asin' },
      { data: 'sales_units_ordered_b2c' },
      { data: 'sales_units_ordered_b2b' },
      { data: 'sales_ordered_product_sales_b2c' },
      { data: 'sales_ordered_product_sales_b2b' },
      { data: 'sales_total_order_items_b2c' },
      { data: 'sales_total_order_items_b2b' },
      { data: 'traffic_browser_sessions_b2c' },
      { data: 'traffic_browser_sessions_b2b' },
      { data: 'traffic_mobile_app_sessions_b2c' },
      { data: 'traffic_mobile_app_sessions_b2b' },
      { data: 'traffic_sessions_b2c' },
      { data: 'traffic_sessions_b2b' },
      { data: 'traffic_browser_session_percentage_b2c' },
      { data: 'traffic_browser_session_percentage_b2b' },
      { data: 'traffic_mobile_app_session_percentage_b2c' },
      { data: 'traffic_mobile_app_session_percentage_b2b' },
      { data: 'traffic_session_percentage_b2c' },
      { data: 'traffic_session_percentage_b2b' },
      { data: 'traffic_browser_page_views_b2c' },
      { data: 'traffic_browser_page_views_b2b' },
      { data: 'traffic_mobile_app_page_views_b2c' },
      { data: 'traffic_mobile_app_page_views_b2b' },
      { data: 'traffic_page_views_b2c' },
      { data: 'traffic_page_views_b2b' },
      { data: 'traffic_browser_page_views_percentage_b2c' },
      { data: 'traffic_browser_page_views_percentage_b2b' },
      { data: 'traffic_mobile_app_page_views_percentage_b2c' },
      { data: 'traffic_mobile_app_page_views_percentage_b2b' },
      { data: 'traffic_page_views_percentage_b2c' },
      { data: 'traffic_page_views_percentage_b2b' },
      { data: 'traffic_buy_box_percentage_b2c' },
      { data: 'traffic_buy_box_percentage_b2b' },
      { data: 'traffic_unit_session_percentage_b2c' },
      { data: 'traffic_unit_session_percentage_b2b' },
      { data: 'created_at' },
      { data: 'actions', orderable: false, searchable: false }
    ]
  })

  initializeDataTable({
    selector: "#aws_regions_table",
    columns: [
      { data: 'id' },
      { data: 'name' },
      { data: 'state' },
      { data: 'zone' }
    ]
  })

  initializeDataTable({
    selector: '#warehouses_table',
    columns: [
      { data: 'id' },
      { data: 'code' },
      { data: 'address' },
      { data: 'postcode' },
      { data: 'city' },
      { data: 'state' },
      { data: 'region' },
      { data: 'actions' }
    ]
  })

  initializeDataTable({
    selector: '#report_ads_keywords_table',
    columns: [
      { data: 'id' },
      { data: 'external_id' },
      { data: 'name' },
      { data: 'bid' },
      { data: 'keyword_type' },
      { data: 'status' },
      { data: 'marketplace_id' },
      { data: 'marketplace_account_id' },
      { data: 'report_ad_campaign' },
      { data: 'created_at' },
      { data: 'actions', orderable: false, searchable: false }
    ]
  })

  initializeDataTable({
    selector: "#campaigns_table",
    columns: [
      { data: "id" },
      { data: "name" },
      { data: "external_id" },
      { data: "marketplace_id" },
      { data: "marketplace_account_id" },
      { data: "bidding_strategy" },
      { data: "budget_amount" },
      { data: "budget_currency" },
      { data: "budget_type" },
      { data: "status" },
      { data: "created_at" },
      { data: "actions" }
    ]
  })

  initializeDataTable({
    selector: '#ad_groups_table',
    columns: [
      { data: 'id' },
      { data: 'name' },
      { data: 'external_id' },
      { data: 'marketplace_id' },
      { data: 'marketplace_account_id' },
      { data: 'report_ad_campaign_id' },
      { data: 'created_at' },
      { data: 'actions' }
    ]
  });

  initializeDataTable({
    selector: '#ads_table',
    columns: [
      { data: "type" },
      { data: "product_title" },
      { data: "total_sale" },
      { data: "total_spend" },
      { data: "term" },
      { data: "clicks" },
      { data: "add_to_list" },
      { data: "impressions" },
      { data: "campaign" },
      { data: "ad_group" },
      { data: "keyword" }
    ]
  })

  initializeDataTable({
    selector: '#discussions-table',
    columns: [
      { data: 'id' },
      { data: 'title' },
      { data: 'creator_name' },
      { data: 'privacy' },
      { data: 'created_at' },
      { data: "actions", orderable: false, searchable: false }
    ]
  })

  initializeDataTable({
    selector: '#meets-table',
    columns: [
      { data: 'id' },
      { data: 'name' },
      { data: 'email' },
      { data: 'meet_time' },
      { data: 'created_at' },
      { data: "actions", orderable: false, searchable: false }
    ]
  })

  initializeDataTable({
    selector: '#packages-table',
    columns: [
      { data: 'id' },
      { data: 'name' },
      { data: 'max_seller_accounts' },
      { data: 'price' },
      { data: 'max_ads_accounts' },
      { data: 'max_skus' },
      { data: 'support_level' },
      { data: 'email_notification' },
      { data: 'actions', orderable: false, searchable: false }
    ]
  })

  initializeDataTable({
    selector: '#categories-table',
    columns: [
      { data: "id" },
      { data: "name" },
      { data: "description" },
      { data: "parent_id" },
      { data: "active" },
      { data: "external_id" },
      { data: "marketplace_id" },
      { data: "created_at" },
      { data: 'actions', orderable: false, searchable: false }
    ]
  })

  initializeDataTable({
    selector: '#subscriptions',
    columns: [
      { data: 'id' },
      { data: 'user_name' },
      { data: 'status' },
      { data: 'billing_start_at' },
      { data: 'billing_end_at' },
      { data: 'created_at' },
      { data: 'actions', orderable: false, searchable: false }
    ]
  })

  initializeDataTable({
    selector: '#sub_subscriptions',
    columns: [
      { data: 'id' },
      { data: 'subscription_id' },
      { data: 'user_name' },
      { data: 'status' },
      { data: 'billing_start_at' },
      { data: 'billing_end_at' },
      { data: 'next_billing_date' },
      { data: 'billing_cycle' },
      { data: 'auto_renew' },
      { data: 'payment_method' },
      { data: 'subscribable_type' },
      { data: 'subscribable_id' },
      { data: 'plan_amount' },
      { data: 'created_at' },
      { data: 'updated_at' },
      { data: 'actions', orderable: false, searchable: false }
    ]
  })

  initializeDataTable({
    selector: '#subscription-invoices',
    columns: [
      { data: 'invoice_number' },
      { data: 'amount' },
      { data: 'amount_due' },
      { data: 'amount_paid' },
      { data: 'status' },
      { data: 'user_name' },
      { data: 'package_name' },
      { data: 'billing_start_at' },
      { data: 'billing_end_at' },
      { data: 'due_at' },
      { data: 'paid_at' },
      { data: 'payment_method' },
      { data: 'gateway_payment_id' },
      { data: 'sub_subscription_id' },
      { data: 'created_at' },
      { data: 'actions' }
    ]
  })

  initializeDataTable({
    selector: '#user-invoices',
    columns: [
      { data: 'id' },
      { data: 'invoice_number' },
      { data: 'amount' },
      { data: 'amount_due' },
      { data: 'amount_paid' },
      { data: 'status' },
      { data: 'user_name' },
      { data: 'package_name' },
      { data: 'billing_start_at' },
      { data: 'billing_end_at' },
      { data: 'due_at' },
      { data: 'paid_at' },
      { data: 'payment_method' },
      { data: 'gateway_payment_id' },
      { data: 'sub_subscription_id' },
      { data: 'created_at' }
    ]
  })


  initializeDataTable({
    selector: '#payments',
    columns: [
      { data: 'id' },
      { data: 'user_name' },
      { data: 'amount' },
      { data: 'payment_method' },
      { data: 'status' },
      { data: 'created_at' },
      { data: 'updated_at' },
      { data: 'actions', orderable: false, searchable: false }
    ]
  });

  initializeDataTable({
    selector: '#audit-history-table',
    columns: [
      { data: "created_at" },
      { data: "user" },
      { data: "auditable_type" },
      { data: "auditable_id" },
      { data: "action" },
      { data: "changes", orderable: false, searchable: false }
    ]
  })

  initStatusScroll({})

  initDateRangePicker('.date-filter');
})

window.initDateRangePicker = function (selector, options = {}) {
  $(selector).each(function () {
    let $element = $(this)
    if ($.fn.daterangepicker) {
      let startDate = localStorage.getItem($element.attr('id') + '_start')
      let endDate = localStorage.getItem($element.attr('id') + '_end')

      const defaultLocale = {
        format: 'DD/MM/YYYY',
        cancelLabel: 'Clear'
      };

      $element.daterangepicker({
        autoUpdateInput: false,
        locale: { ...defaultLocale, ...(options.locale || {}) },
        ...(startDate && endDate ? {
          startDate: moment(startDate),
          endDate: moment(endDate)
        } : {})
      })

      $element.on('apply.daterangepicker', (ev, picker) => {
        $element.val(picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY'))
        localStorage.setItem($element.attr('id') + '_start', picker.startDate.format('YYYY-MM-DD'))
        localStorage.setItem($element.attr('id') + '_end', picker.endDate.format('YYYY-MM-DD'))
        setTimeout(() => {
          $element.trigger('keyup')
        }, 400)
      })

      $element.on('cancel.daterangepicker', (ev, picker) => {
        $element.val('')
        picker.setStartDate(moment());
        picker.setEndDate(moment());
        localStorage.removeItem($element.attr('id') + '_start')
        localStorage.removeItem($element.attr('id') + '_end')
        setTimeout(() => {
          $element.trigger('keyup')
        }, 400)
      })

      if (startDate && endDate) {
        $element.val(moment(startDate).format('DD/MM/YYYY') + ' - ' + moment(endDate).format('DD/MM/YYYY'))
      }
    }
  })
}

window.buttonsMinConfig = function (title, isProductwiseTable, sectionName) {
  const csvButton = isProductwiseTable ?
    {
      extend: 'csvHtml5',
      text: '<i class="bi bi-filetype-csv"></i>',
      titleAttr: title,
      filename: title,
      exportOptions: {
        columns: ':not(.not_export)'
      },
      bom: true,
      fieldSeparator: ',',
      charset: 'utf-8', //  ADD THIS
      customize: function (csv) {
        //  NORMALIZE LINE ENDINGS FIRST
        csv = csv.replace(/\r\n/g, '\n').replace(/\r/g, '\n');

        if (sectionName === 'productGrowth') {
          const rows = csv.split('\n');

          const result = rows
            .map((row, index) => {
              if (!row.trim()) return "";

              //  Split CSV safely — ignore commas inside quotes
              let cells = row.match(/(".*?"|[^",]+)(?=,|$)/g)?.map(c => c.replace(/^"|"$/g, "")) || [];

              // 🔹 Header row
              if (index === 0) {
                const nameIndex = cells.findIndex(c => c.toLowerCase() === "name");
                if (nameIndex !== -1) {
                  cells.splice(nameIndex, 1, "ASIN", "SKU", "BRAND");
                }
                return cells.join(",");
              }

              // 🔹 Data rows
              if (cells.length > 0) {
                const nameIndex = cells.findIndex((_, i) => i === 0 || _.toLowerCase() === "name");
                const nameCell = nameIndex !== -1 ? cells[nameIndex] : cells[0];
                const text = (nameCell || "").replace(/\s+/g, " ").trim();

                // Extract clean ASIN, SKU, BRAND
                const asinMatch = text.match(/ASIN[:\-]?\s*([A-Z0-9]+)/i);
                const skuMatch = text.match(/SKU[:\-]?\s*([^,|]*)/i);
                const brandMatch = text.match(/Brand[:\-]?\s*([^,|]*)/i);

                const asin = asinMatch ? asinMatch[1].trim() : "";
                const sku = skuMatch ? skuMatch[1].replace(/Brand[:\-]?.*/i, "").trim() : "";
                const brand = brandMatch ? brandMatch[1].trim() : "";

                //  Replace only the NAME column, nothing else
                if (nameIndex !== -1) {
                  cells.splice(nameIndex, 1, `"${asin}"`, `"${sku}"`, `"${brand}"`);
                } else {
                  cells.splice(0, 1, `"${asin}"`, `"${sku}"`, `"${brand}"`);
                }
              }

              //  Join safely with commas and escape quotes
              return cells.map(v => {
                const cleanV = String(v).replace(/"/g, '""');
                return v.includes(",") || v.includes('"') || v.includes('\n') ? `"${cleanV}"` : v;
              }).join(",");
            })
            .filter(row => row.length > 0) //  Remove empty rows
            .join("\r\n"); //  USE WINDOWS LINE ENDINGS

          return result;
        }
        else if (sectionName === 'campaignName') {
          const rows = csv.split('\n');

          const isAdGroupTable = sectionName === 'adGroup';
          const isSearchLikeTable = ['targeting', 'searchTerm', 'customSearchTerm'].includes(sectionName);
          const extractProductData = (text) => {
            let cleanText = text.replace(/\s+/g, " ").trim();

            // Remove numbering (e.g., 12#)
            cleanText = cleanText.replace(/^\d+\s*#\s*/, "");

            // Extract SKU
            const skuMatch = cleanText.match(/SKU[:\-]?\s*([^|,]+)/i);
            const sku = skuMatch ? skuMatch[1].trim() : "";

            // Extract ASIN (Amazon ASIN = 10 chars alphanumeric)
            const asinMatch = cleanText.match(/\b[A-Z0-9]{10}\b/);
            const asin = asinMatch ? asinMatch[0] : "";

            // Extract Brand
            const brandMatch = cleanText.match(/Brand[:\-]?\s*([^|,]+)/i);
            const brand = brandMatch ? brandMatch[1].trim() : "";

            // Remove extracted parts to get Product Name
            let productName = cleanText
              .replace(/SKU[:\-]?\s*[^|,]+/gi, "")
              .replace(/Brand[:\-]?\s*[^|,]+/gi, "")
              .replace(/\b[A-Z0-9]{10}\b/, "")
              .replace(/\|/g, "")
              .trim();

            return { productName, brand, asin, sku };
          };

          const result = rows.map((row, index) => {
            if (!row.trim()) return "";

            // Safe CSV split
            let cells = row.match(/(".*?"|[^",]+)(?=,|$)/g)
              ?.map(c => c.replace(/^"|"$/g, "")) || [];
            const isProductTable = sectionName === 'productGrowth' || (cells[0] || "").toUpperCase().includes("PRODUCT NAME");

            // =========================
            // HEADER PROCESSING
            // =========================
            if (index === 0) {
              const firstHeader = (cells[0] || "").toUpperCase();


              // ADGROUP header fix
              if (firstHeader.includes("ADGROUP NAME")) {
                cells.splice(0, 1, "ADGROUP NAME", "CAMPAIGN NAME");
              }

              // CAMPAIGN header fix
              if (firstHeader.includes("CAMPAIGN NAME")) {
                cells.splice(1, 0, "STATUS", "BUDGET");
              }

              // PRODUCT TABLE ONLY → add columns
              if (isProductTable) {
                const nameIndex = cells.findIndex(c => c.toLowerCase() === "name" || c.toLowerCase() === "product name");
                const targetIndex = nameIndex !== -1 ? nameIndex : 0;
                cells.splice(targetIndex + 1, 0, "BRAND", "ASIN", "SKU");
              }

              // ADGROUP TABLE → remove unwanted columns if present
              if (isAdGroupTable) {
                cells = cells.filter(
                  col => !["BRAND", "ASIN", "SKU"].includes(col.toUpperCase())
                );
              }

              return cells.map(v => `"${v.replace(/"/g, '""')}"`).join(",");
            }

            // =========================
            // DATA PROCESSING
            // =========================
            if (cells[0]) {
              let text = cells[0].trim();

              // Extract campaign name if exists
              const campaignMatch = text.match(/Campaign Name\s*:\s*(.*)$/i);
              if (campaignMatch) {
                const campaignName = campaignMatch[1].trim();

                text = text
                  .replace(/Campaign Name\s*:\s*.*$/i, "")
                  .replace(/ASIN[:\-]?\s*[^|,\n]*/gi, "")
                  .replace(/SKU[:\-]?\s*[^|,\n]*/gi, "")
                  .replace(/Brand[:\-]?\s*[^|,\n]*/gi, "")
                  .replace(/\|/g, "")
                  .replace(/\s+/g, " ")
                  .trim();

                cells.splice(0, 1, text, campaignName);
              }
              // =========================
              // CAMPAIGN ROW
              // =========================
              if (text.includes("Budget") || text.includes("ENABLED") || text.includes("PAUSED")) {
                let parts = text.split(/\s{5,}/).map(p => p.trim()).filter(Boolean);

                const campaignName = parts[0] || "";
                const status = parts[1] || "";
                const budget = parts.slice(2).join(" ").replace(/Budget/gi, "").trim();

                cells[0] = campaignName;
                cells.splice(1, 0, status, budget);
              }

              // =========================
              // PRODUCT TABLE ONLY
              // =========================

              else if (isProductTable || (cells[0] || "").includes("SKU:")) {
                let text = cells[0].replace(/\s+/g, " ").trim();

                // 1. Remove numbering like 52# 3# 12#
                text = text.replace(/^\d+\s*#\s*/g, "").trim();

                // 2. Extract SKU (Matches everything after "SKU:")
                const skuMatch = text.match(/SKU[:\-]?\s*(.*)$/i);
                let sku = skuMatch ? skuMatch[1].trim() : "";

                // 3. Temporary section excluding SKU for cleaner matching
                let mainSection = text.replace(/SKU[:\-]?.*$/i, "").trim();

                let brand = "";
                let asin = "";
                let productName = "";

                // 4. Identify the "ASIN/ID" (e.g., THEMI9774F) 
                // We look for 5+ uppercase letters/numbers at the end of the string
                const idMatch = mainSection.match(/\b([A-Z0-9]{5,})\b$/);
                if (idMatch) {
                  asin = idMatch[0];
                  // Remove the ASIN from the working string immediately
                  mainSection = mainSection.replace(asin, "").trim();
                }

                // 5. Split between Product Name and Brand Name
                if (mainSection.toLowerCase().includes("brand:")) {
                  const parts = mainSection.split(/brand:/i);
                  productName = parts[0].trim();
                  brand = parts[1] ? parts[1].trim() : "";
                } else {
                  // If no "Brand:" label, we assume the remaining text is the Brand
                  brand = mainSection;
                  productName = brand;
                }

                // 6. Word wrapping 10 words per line for Product Name column
                const words = productName.split(" ");
                if (words.length > 10) {
                  const wrappedParts = [];
                  for (let i = 0; i < words.length; i += 10) {
                    wrappedParts.push(words.slice(i, i + 10).join(" "));
                  }
                  productName = wrappedParts.join("\n");
                }

                // 7. Push final data into the row array
                cells[0] = productName;
                // Order: Product Name [0], Brand [1], ASIN [2], SKU [3]
                cells.splice(1, 0, brand, asin, sku);
              }

              // =========================
              // ADGROUP TABLE FIX
              // =========================
              if (isAdGroupTable) {
                // Remove extra Brand/ASIN/SKU if mistakenly present
                cells = cells.filter((_, idx) => idx < 2 || idx > 4);
              }

              // =========================
              // SEARCH / TARGETING TABLE FIX
              // =========================
              if (isSearchLikeTable) {
                // Ensure no extra columns are added
                cells = cells.slice(0, cells.length);
              }
            }

            // =========================
            // FINAL FORMAT
            // =========================
            return cells.map(v => `"${String(v).replace(/"/g, '""')}"`).join(",");
          })
            .filter(Boolean)
            .join("\r\n");

          return result;
        }
        else {
          const rows = csv.split('\n');

          const result = rows
            .map((row, index) => {
              if (!row.trim()) return ""; // Skip empty rows

              // Split by comma but ignore commas inside quotes
              let cells = row.match(/(".*?"|[^",]+)(?=,|$)/g)?.map(c => c.replace(/^"|"$/g, "")) || [];

              // ============================
              // HEADER ROW
              // ============================
              if (index === 0) {
                if (!row.toLowerCase().includes("brand")) {
                  cells.splice(1, 0, "Brand", "ASIN", "SKU");
                }

                // Quote header cells that need it
                cells = cells.map(c => {
                  const cleanC = String(c).replace(/"/g, '""');
                  return c.includes(",") || c.includes('"') ? `"${cleanC}"` : c;
                });
                return cells.join(",");
              }

              // ============================
              // PRODUCT NAME PROCESSING
              // ============================
              if (cells[0]) {
                let text = cells[0].replace(/\s+/g, " ").trim();

                // Remove numbering like 52# 3# 12#
                text = text.replace(/^\s*\d+\s*#\s*/g, "").trim();

                // Extract Brand, ASIN, SKU
                const brandMatch = text.match(/Brand[:\-]?\s*([^|,\n]*)/i);
                const asinMatch = text.match(/ASIN[:\-]?\s*([A-Z0-9\-]+)/i);
                const skuMatch = text.match(/SKU[:\-]?\s*([^|,\n]+)/i);

                let brand = brandMatch ? brandMatch[1].trim() : "";
                let asin = asinMatch ? asinMatch[1].trim() : "";
                let sku = skuMatch ? skuMatch[1].trim() : "";

                // Remove garbage inside brand
                brand = brand.replace(/ASIN[:\-]?\s*[^\|,]*/gi, "").trim();

                // CLEAN PRODUCT NAME
                let productName = text
                  .replace(/Brand[:\-]?\s*[^|,\n]*/i, "")
                  .replace(/ASIN[:\-]?\s*[^|,\n]*/i, "")
                  .replace(/SKU[:\-]?\s*[^|,\n]*/i, "")
                  .replace(/\|/g, "")
                  .trim();

                // Word wrapping 10 words per line
                const words = productName.split(" ");
                if (words.length > 10) {
                  const parts = [];
                  for (let i = 0; i < words.length; i += 10) {
                    parts.push(words.slice(i, i + 10).join(" "));
                  }
                  productName = parts.join("\n");
                }

                // Push final data
                cells[0] = productName;
                cells.splice(1, 0, brand, asin, sku);
              }

              // ============================
              // FINAL FIX: QUOTE ALL CELLS PROPERLY
              // ============================
              cells = cells.map(c => {
                const cleanC = String(c).replace(/"/g, '""');
                // Quote if contains comma, quote, or newline
                return c.includes(",") || c.includes('"') || c.includes('\n') ? `"${cleanC}"` : cleanC;
              });

              return cells.join(",");
            })
            .filter(row => row.length > 0) //  Remove empty rows
            .join("\r\n"); //  USE WINDOWS LINE ENDINGS

          return result;
        }
      }
    } : {
      extend: 'csv',
      text: '<i class="bi bi-filetype-csv"></i>',
      titleAttr: title,
      filename: title,
      exportOptions: {
        columns: ':not(.not_export)'
      },
      bom: true, //  ADD BOM for non-productwise tables too
      charset: 'utf-8' //  ADD THIS
    }

  return [
    csvButton,
    ...(!isProductwiseTable || sectionName
      ? [
        {
          extend: 'print',
          text: '<i class="bi bi-printer"></i>',
          titleAttr: title,
          exportOptions: {
            columns: ':not(.not_export)'
          },
          customize: function (win) {
            $(win.document.body).css({
              'background': '#ffffff',
              'font-size': '10px',
              'padding': '90px 20px'
            });
            const style = `
              <style>
                @page {
                  margin: 0;
                  size: auto;
                }
              </style>
            `;
            $(win.document.body).append(style);

            $(win.document.body).find('table')
              .css({
                'background': '#fff',
                'border-radius': '8px',
                'box-shadow': '0 0 15px rgba(0,0,0,0.15)',
                'padding': '10px',
                'border-collapse': 'separate',
                'margin-top': '30px'
              });

            $(win.document.body).prepend(
              `<img alt="Gapalyze logo" src=${logo} style="position:absolute; top:20px; left:20px; width:200px;" />`
            );

            $(win.document.body).find('table th').css({
              'background': '#f5f5f5',
              'padding': '6px',
              'border-radius': '4px',
              'font-size': '12px'
            });

            $(win.document.body).find('table td').css({
              'padding': '6px',
              'font-size': '12px'
            });
          }
        }
      ]
      : [])
  ];
};


window.buttonsConfig = function (title) {
  [
    {
      extend: 'copyHtml5',
      text: '<i class="bi bi-clipboard"></i>',
      titleAttr: title,
      exportOptions: {
        columns: ':not(.not_export)'
      }
    },
    {
      extend: 'csvHtml5',
      text: '<i class="bi bi-filetype-csv"></i>',
      titleAttr: title,
      filename: title,
      exportOptions: {
        columns: ':not(.not_export)' // specify the columns to export
      }
    },
    {
      extend: 'excelHtml5',
      text: '<i class="bi bi-file-earmark-excel"></i>',
      titleAttr: title,
      filename: title,
      exportOptions: {
        columns: ':not(.not_export)'
      }
    },
    {
      extend: 'pdfHtml5',
      text: '<i class="bi bi-file-earmark-pdf"></i>',
      titleAttr: title,
      filename: title,
      exportOptions: {
        columns: ':not(.not_export)'
      },
      customize: function (doc) {
        doc.styles.tableHeader.alignment = 'left';
        doc.content[1].table.widths = ['33%', '33%', '34%'];
      }
    },
    {
      extend: 'print',
      text: '<i class="bi bi-printer"></i>',
      titleAttr: title,
      exportOptions: {
        columns: ':not(.not_export)'
      },
      customize: function (win) {
        // Set body background and font
        $(win.document.body).css({
          'background': '#ffffff',
          'font-size': '10px',
          'padding': '90px 20px'
        });
        const style = `
        <style>
                @page {
                  margin: 0;
                  size: auto;
                }
              </style>`
        $(win.document.body).append(style);

        // Add shadow to entire page
        $(win.document.body).find('table')
          .css({
            'background': '#fff',
            'border-radius': '8px',
            'box-shadow': '0 0 15px rgba(0,0,0,0.15)',
            'padding': '10px',
            'border-collapse': 'separate'
          });

        // Add logo (optional)
        $(win.document.body).prepend(
          `<img alt="Gapalyze logo" src=${logo} style="position:absolute; top:20px; left:20px; width:200px;" />`
        );

        // Style table headers
        $(win.document.body).find('table th').css({
          'background': '#f5f5f5',
          'padding': '6px',
          'border-radius': '4px',
          'font-size': '12px'
        });

        // Style table rows
        $(win.document.body).find('table td').css({
          'padding': '6px',
          'font-size': '12px'
        });
      }
    }
  ]
}

const iconClasses = {
  'buttons-copy': 'bi-clipboard',
  'buttons-csv': 'bi-filetype-csv',
  'buttons-excel': 'bi-filetype-xls',
  'buttons-pdf': 'bi-filetype-pdf',
  'buttons-print': 'bi-printer'
};

window.initializeDataTable = function ({
  ajaxUrl,
  selector,
  columns,
  not_orderable = [],
  order = [],
  pagingType = 'simple_numbers',
  dom = "<'row custom_data_filter_col'<'col-6 custom_datatable'f><'col-6 text-end d-flex justify-content-end align-items-center gap-2'B<'filter-btn-wrap'>>>" +
  "<'row'<'col-sm-12 table-responsive hide-scrollbar'tr>>" +
  "<'row mgltm0'<'col-sm-5 show-entry'li><'col-sm-7'p>>",
  buttons = buttonsConfig("Data Export"),
  extraAjaxData = {},
  filtersContainerClass = 'filters',
  filterInputSelectors = 'input.default_input, select.select2-multiple',
  class_name = 'order-enable'
}) {
  const table = $(selector);
  // Default AJAX error handler

  if ($.fn.DataTable.isDataTable(selector)) {
    table.DataTable().clear().destroy();
  }

  const defaultErrorHandler = function (xhr, error, thrown) {
    console.error('DataTables ajax error:', thrown);
  };

  return table.DataTable({
    oLanguage: {
      sLengthMenu: "Show Entries _MENU_",
      sProcessing: "<div class='ld_ind_wrp'></div>",
      sSearch: "",
      oPaginate: {
        sNext: '<i class="bi bi-chevron-right"></i>',
        sPrevious: '<i class="bi bi-chevron-left"></i>'
      }
    },
    lengthMenu: [[10, 25, 50, 100, 200, 500], [10, 25, 50, 100, 200, 500]],
    orderCellsTop: true,
    processing: true,
    serverSide: true,
    bStateSave: false,
    pagingType: pagingType,
    dom: dom,
    buttons: buttonsConfig("Data Export"),
    columns: columns,
    order: order,
    columnDefs: [
      {
        orderable: false,
        targets: not_orderable.length ? not_orderable : 'checkbox-col',
        className: "select-checkbox sticky-col checkbox-col"
      }
    ],

    ajax: {
      url: table.data('source') || ajaxUrl,
      dataSrc: function (json) {
        return json.data;
      },
      data: function (d) {
        return $.extend({}, d, extraAjaxData);
      },
      error: defaultErrorHandler
    },

    initComplete: function (oSettings, json) {
      var cols = oSettings.aoPreSearchCols;
      for (var i = 0; i < cols.length; i++) {
        var value = cols[i].sSearch;
        if (typeof value == "string" && value.length > 0 && value != "null") {
          $(`.${class_name}`).addClass("order-enable");
          var selection = $(`.${filtersContainerClass} ${filterInputSelectors}`);
          var data_type = selection[i].type;
          if (data_type == "text") {
            selection[i].value = value;
          } else {
            var record_id = selection[i].id;
            $("#" + record_id).val(value.split("|"));
            $("#" + record_id).parent().find(".select2-search__field").val(value.split("|"));
          }
        }
      }

      if (['products_table', 'admin_orders_table', 'analytics_sale_table', 'analytics_traffic_table'].includes($(table).attr('id'))) {
        $('.filter-btn-wrap').html(`
          <button id="toggleFilter" class="btn btn-outline-secondary btn-sm" type="button">
            <i class="bi bi-funnel-fill me-1"></i> Filters
          </button>
        `);
      } else {
        $('.filter-toggle-wrap').remove(); // Don’t show button for other tables
      }
      return $(`.${filtersContainerClass} ${filterInputSelectors}`).on('keyup change clear', (function (_this) {
        return function (e) {
          var th;
          var search_value;
          th = $(e.target).closest("th");
          var value = $(e.target).val();
          if (Array.isArray(value)) {
            search_value = value.length ? value.join("|") : '';
          } else if (typeof value === "string") {
            search_value = value.trim();
          } else {
            search_value = '';
          }
          return _this.api().column(th.index()).search(search_value).draw();
        };
      })(this));
    }
  }).buttons().container().find('button').each(function () {
    const buttonClass = $(this).attr('class').split(' ').find(cls => cls.startsWith('buttons-'));
    if (buttonClass && iconClasses[buttonClass]) {
      $(this).html(`<i class="bi ${iconClasses[buttonClass]}"></i>`);
      $(this).attr("title", buttonClass.split('-')[1].toLocaleUpperCase());
    }
  });
}

window.initializeNormalDataTable = function ({
  selector,
  not_orderable = [],
  order = [],
  pagingType = 'simple_numbers',
  dom = null, // <- set default below based on route
  class_name = 'order-enable',
  pageLength = 10,
  downloadBtnPermission,
  isProductwiseTable = false,
  sectionName,
  orderMulti
}) {
  const table = $(selector);

  // Check if current route is dashboard
  const isDashboardRoute = window.location.pathname.includes("/dashboard");

  // Define base dom
  let baseDom = "<'row custom_data_filter_col normal-view'<'col-6 custom_datatable'f><'col-6 text-end'B>>" +
    "<'row normal-view'<'col-sm-12 table-responsive hide-scrollbar'tr>>" +
    "<'row mgltm0 normal-view'<'col-sm-5 show-entry'li><'col-sm-7'p>>";

  // Modify dom if dashboard — add style="display:none" inline to hide show-entry
  if (isDashboardRoute) {
    baseDom = baseDom.replace("col-sm-5 show-entry", "col-sm-5 show-entry-new\"");
  }

  return table.DataTable({
    oLanguage: {
      sLengthMenu: "Show Entries _MENU_",
      sProcessing: "<div class='ld_ind_wrp'></div>",
      sSearch: "",
      oPaginate: {
        sNext: '<i class="bi bi-chevron-right"></i>',
        sPrevious: '<i class="bi bi-chevron-left"></i>'
      }
    },
    lengthMenu: [[5, 10, 25, 50, 100, 200, 500], [5, 10, 25, 50, 100, 200, 500]],
    pageLength,
    orderCellsTop: true,
    processing: true,
    bStateSave: true,
    pagingType: pagingType,
    dom: downloadBtnPermission
      ? (dom || baseDom)
      : (dom || baseDom).replace(/B/g, ''),

    ...(downloadBtnPermission ? { buttons: buttonsMinConfig("Data Export", isProductwiseTable, sectionName) } : {}),
    order: order,
    orderFixed: [[0, 'asc']],
    columnDefs: [
          {
      targets: 0,
      visible: false,  // hide priority column
      searchable: false
    },
      {
        orderable: false,
        targets: not_orderable.length ? not_orderable : 'checkbox-col',
        className: "select-checkbox sticky-col checkbox-col"
      }
    ],
  })
}



window.productGrowthDataTable = function ({
  selector,
  not_orderable = [],
  order = [],
  pagingType = 'simple_numbers',
  dom = null,
  class_name = 'order-enable',
  pageLength = 10,
  title = "",
  range = "",
  downloadBtnPermission
}) {
  const table = $(selector);

  const isDashboardRoute = window.location.pathname.includes("/dashboard");

  //  Title on left, Buttons on right
  let baseDom = "<'row custom_data_filter_col normal-view-product'<'col-sm-6 custom_title'><'col-sm-6 text-end'B>>" +
    "<'row normal-view'<'col-sm-12 table-responsive hide-scrollbar'tr>>" +
    "<'row mgltm0 normal-view'<'col-sm-5 show-entry'li><'col-sm-7'p>>";

  if (isDashboardRoute) {
    baseDom = baseDom.replace("col-sm-5 show-entry", "col-sm-5 show-entry-new\"");
  }

  const dataTable = table.DataTable({
    oLanguage: {
      sLengthMenu: "Show Entries _MENU_",
      sProcessing: "<div class='ld_ind_wrp'></div>",
      oPaginate: {
        sNext: '<i class="bi bi-chevron-right"></i>',
        sPrevious: '<i class="bi bi-chevron-left"></i>'
      }
    },
    lengthMenu: [[5, 10, 25, 50, 100, 200, 500], [5, 10, 25, 50, 100, 200, 500]],
    pageLength,
    orderCellsTop: true,
    processing: true,
    bStateSave: true,
    pagingType: pagingType,
    dom: downloadBtnPermission
      ? (dom || baseDom)
      : (dom || baseDom).replace(/B/g, ''),

    ...(downloadBtnPermission ? { buttons: buttonsMinConfig("Data Export", true, 'productGrowth') } : {}),

    order: order,
    columnDefs: [
      {
        orderable: false,
        targets: not_orderable.length ? not_orderable : 'checkbox-col',
        className: "select-checkbox sticky-col checkbox-col"
      }
    ],

    //  Run after DataTable is fully rendered
    initComplete: function () {
      $(this.api().table().container())
        .find(".custom_title")
        .html(`<h6 class="table-title m-0" style="display: flex; flex-direction: column; padding: 0px !important;"><span>${title}</span><small style="color: #9b9b9b; font-size: 0.78rem; margin-top: 2px; margin-left: 0px;"></small></h6>
      `);
    }
  });


  return dataTable;
};



window.initStatusScroll = function () {
  const $scrollContainer = $('#statusScroll');
  if (!$scrollContainer.length) return;

  const $leftBtn = $('.scroll-btn.left');
  const $rightBtn = $('.scroll-btn.right');

  setupScrollButtons($scrollContainer, $leftBtn, $rightBtn);
  bindScrollEvents($scrollContainer, $leftBtn, $rightBtn);
  updateArrowVisibility($scrollContainer, $leftBtn, $rightBtn);
  scrollActiveTabIntoView($scrollContainer);
}

window.setupScrollButtons = function ($scrollContainer, $leftBtn, $rightBtn, scrollAmount = 200) {
  $leftBtn.on('click', () => {
    $scrollContainer[0].scrollBy({ left: -scrollAmount, behavior: 'smooth' });
  });

  $rightBtn.on('click', () => {
    $scrollContainer[0].scrollBy({ left: scrollAmount, behavior: 'smooth' });
  });
}

window.updateArrowVisibility = function ($scrollContainer, $leftBtn, $rightBtn) {
  const scrollWidth = $scrollContainer[0].scrollWidth;
  const containerWidth = $scrollContainer.outerWidth();
  const scrollLeft = $scrollContainer.scrollLeft();

  const isOverflowing = scrollWidth > containerWidth;

  if (isOverflowing) {
    $leftBtn.toggle(scrollLeft > 0);
    $rightBtn.toggle(scrollLeft + containerWidth < scrollWidth - 1);
  } else {
    $leftBtn.hide();
    $rightBtn.hide();
  }
}

window.scrollActiveTabIntoView = function ($scrollContainer) {
  const $activeTab = $scrollContainer.find('.status.active');

  if ($activeTab.length) {
    const offsetLeft = $activeTab.position().left;
    const scrollOffset = offsetLeft - $scrollContainer.width() / 2 + $activeTab.outerWidth() / 2;
    $scrollContainer.animate({ scrollLeft: scrollOffset }, 400);
  }
}

window.bindScrollEvents = function ($scrollContainer, $leftBtn, $rightBtn) {
  $scrollContainer.on('scroll', () => {
    updateArrowVisibility($scrollContainer, $leftBtn, $rightBtn);
  });

  $(window).on('resize', () => {
    updateArrowVisibility($scrollContainer, $leftBtn, $rightBtn);
  });

  $scrollContainer.on('click', '.status', function () {
    setTimeout(() => {
      updateArrowVisibility($scrollContainer, $leftBtn, $rightBtn);
    }, 300);
  });
}


document.addEventListener("turbo:load", () => {
  let deleteUrl = null;

  document.addEventListener("click", (e) => {
    const target = e.target.closest(".delete-onboarding");
    if (!target) return;

    e.preventDefault();

    deleteUrl = target.dataset.url;  // <-- URL yahan se milega
    const modal = new bootstrap.Modal(document.getElementById("deleteModal"));
    modal.show();
  });

  document.getElementById("confirmDeleteBtn")?.addEventListener("click", () => {
    if (!deleteUrl) return;

    fetch(deleteUrl, {
      method: "DELETE",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "Accept": "application/json"
      }
    }).then(response => {
      if (response.ok) {
        location.reload()
      }
    });
  });
});



